import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { getIntegrityMonitorEntityTypes } from '../types';

export const template = document.createElement('template');

const entityForms = getIntegrityMonitorEntityTypes()
  .filter(form => form.implemented)
  .map(entity => `<${entity.formTag} hidden></${entity.formTag}>`);

template.innerHTML = `
  <style>${styles}</style>
  <style>${commonStyles}</style>

  <div class='form-wrapper' id='rule-form-wrapper'>
    <div class='form-section'>
      <gz-title fontSize='18' fontWeight='500' class='form-subtitle' id='general-subtitle'></gz-title>

      <gz-form-field id='rule-name-form-field' class='label-mw-250' label='' required>
        <gz-input gz-form-input inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='rule-description-form-field' class='label-mw-250' label=''>
        <gz-input gz-form-input inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='rule-severity-form-field' class='label-mw-250' label='' required>
        <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='rule-entitytype-form-field' class='label-mw-250' label='' required>
        <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>
    </div>

    ${entityForms.join('\n')}
  </div>
`;
